import gql from "graphql-tag";
import graphqlClient, { fragments } from "@/http/graphql/inside";
import graphqlCbs from "@/http/graphql/cbs";

const GET_EMPLOYEES = `
	employees (limit: $limit,
		page: $page,
		search: $search,
		orderBy: $orderBy,
		department_id: $department_id,
		department_ids: $department_ids) {
		data {
			...Employee
		}
		total
	}
`;

const GET_EMPLOYEE = `
	employee (id: $id) {
		...Employee
	}
`;

const GET_EMPLOYEES_FOR_POST = `
	employees (limit: -1, page: 1, is_activated: $is_activated) {
		data {
			avatar(w: 100, h: 100)
			name
		}
	}`;
const EMPLOYEE_HAS_BIRTHDAY = ` 
export_employee_has_birthday(month: $month) 
	  `;

const EXPORT_MONTHLY_KPI = `
	export_monthly_kpi(id: $id)
`;

const EMPLOYEES_KPI = ` 
export_employees_kpi(month: $month) 
`;

export default {
	init() {},

	exportMonthlyKPI(id) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ExportMonthlyKPI ($id: Int!) {
					${EXPORT_MONTHLY_KPI}
				}
			`,
				variables: {
					id
				}
			})
			.then(response => response.data.export_monthly_kpi);
	},

	fetchEmployees(payload) {
		const queryOptions = {
			query: gql`query Employees ($limit: Int!,
				$page: Int!,
				$search: String,
				$department_id: Int,
				$orderBy: OrderByObject,
				$department_ids: [Int]) {
				${GET_EMPLOYEES}
			}
			${fragments.Title}
			${fragments.Employee}
			${fragments.Department}
			`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1,
				search: payload.search || "",
				department_id: payload.department_id,
				orderBy: payload.orderBy || { column: "id", direction: "desc" },
				department_ids: payload.department_ids || []
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				employees: response.data.employees.data,
				total: response.data.employees.total
			};
		});
	},

	getEmployee(employeeId) {
		const queryOptions = {
			query: gql`query EmployeesManagementDetail ($id: Int!) {
					${GET_EMPLOYEE}
				}
				${fragments.Title}
				${fragments.Employee}
				${fragments.Department}
			`,
			variables: {
				id: employeeId
			}
		};

		return graphqlClient.query(queryOptions).then(response => {
			return {
				employee: response.data.employee
			};
		});
	},
	fetchEmployeesForPost() {
		const queryOptions = {
			query: gql`query EmployeesForPost ($is_activated: Boolean) {
				${GET_EMPLOYEES_FOR_POST}
			}
			`,
			variables: {
				is_activated: true
			}
		};

		return graphqlClient.query(queryOptions).then(response => {
			return {
				employees: response.data.employees.data
			};
		});
	},
	downloadEmployeeHasBirthday(payload) {
		return graphqlCbs
			.query({
				query: gql`query EMPLOYEE_HAS_BIRTHDAY ($month: Int) {
					${EMPLOYEE_HAS_BIRTHDAY}
				}
			`,
				variables: {
					month: payload && payload.month ? payload.month : null
				}
			})
			.then(response => response.data.export_employee_has_birthday);
	},
	downloadEmployeesKpi(payload) {
		return graphqlCbs
			.query({
				query: gql`query EMPLOYEES_KPI ($month: Int) {
					${EMPLOYEES_KPI}
				}
			`,
				variables: {
					month: payload && payload.month ? payload.month : null
				}
			})
			.then(response => response.data.export_employees_kpi);
	}
};
